import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["word"];

  connect() {
    if (this.wordTargets.length > 0) {
      this.wordIndex = 0;
      this.words = this.wordTargets;

      // Set initial state - only first word visible
      this.words.forEach((word, index) => {
        if (index === 0) {
          word.classList.remove("hidden");
        } else {
          word.classList.add("hidden");
        }
      });

      this.startWordAnimation();
    }
  }

  startWordAnimation() {
    this.animationInterval = setInterval(() => {
      // Hide current word
      this.words[this.wordIndex].classList.add("hidden");

      // Move to next word
      this.wordIndex = (this.wordIndex + 1) % this.words.length;

      // Show next word
      this.words[this.wordIndex].classList.remove("hidden");
    }, 3000);
  }

  disconnect() {
    if (this.animationInterval) {
      clearInterval(this.animationInterval);
    }
  }
}
